import React from 'react';
import {Button, Collapse} from 'reactstrap';
import PropTypes from 'prop-types';

class DialogCollapseSection extends React.Component{

    constructor(props){
        super(props);
        this.state = {
            isOpen: props.initiallyOpen,
            showText:  props.showText,
            hideText: props.hideText
        };

        this.handleToggle = this.toggle.bind(this);
    }

    toggle(){

        const cState = !this.state.isOpen;

        if(cState && this.props.onExpand)
            this.props.onExpand();

        if(!cState && this.props.onCollapse)
            this.props.onCollapse();

        this.setState({isOpen: cState });
    }

    render(){

        const showText=  this.state.showText;
        const hideText = this.state.hideText;
        const props = this.props;
        const showToggle = props.showToggle == undefined ? true : this.props.showToggle;

        return (<div>
            <div className="clearfix">

                <div className="pull-left">
                    {typeof this.props.title == "string" ? <h5>{this.props.title}</h5> : this.props.title}
                </div>

                {showToggle && <div className="pull-right">
                    {props.toggleRender ? props.toggleRender(this.state.isOpen , this.state.isOpen ? hideText : showText ,  this.handleToggle ) : <Button style={{minWidth: '90px'}} color="link" onClick={this.handleToggle}>{this.state.isOpen ? <span>{hideText} <i className="fa fa-angle-up"></i></span> : <span>{showText} <i className="fa fa-angle-down"></i></span>}</Button>}
                </div>}

            </div>
            <Collapse isOpen={this.state.isOpen} style={{marginBottom: '5px'}}>
                {this.props.children}
            </Collapse>
        </div>);
    }
}

DialogCollapseSection.propTypes = {
    title: PropTypes.any,
    showText : PropTypes.string,
    hideText: PropTypes.string,
    showToggle: PropTypes.bool,
    initiallyOpen: PropTypes.bool,
    toggleRender : PropTypes.func,
    onExpand: PropTypes.func,
    onCollapse: PropTypes.func
};

DialogCollapseSection.defaultProps = {
    initiallyOpen: false,
    showText: 'Show',
    hideText: 'Hide'
};

export default DialogCollapseSection;


// WEBPACK FOOTER //
// ./src/components/DialogCollapseSection/DialogCollapseSection.js